<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: Home
 * @Description: 益华集团介绍
 * @FilePath: /app-tikfriend_web/src/pages/content/Home.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-12 00:21:10
 * @LastEditors: hselenat
 * @LastEditTime: 2021-08-23 09:25:06
 * @example: 调用示例
-->
<template>
    <div class="home-x">
        <section class="section-x">
            <div class="art-item">
                <div><img src="@/assets/images/yihua.png" alt="益华" class="art-img"></div>
                <div class="art-content art-p">
                    <p>益华电脑城是福建益华集团公司成员企业之一，是泉州益华房地产公司开发建造的综合性大厦，位于泉州市区九一街中段的益华商厦，大厦设施完备、先进、配套齐全，商场面积达15000多平方米，写字楼22000多平方米，80多个地下停车场位。</p>

                    <p>益华电脑城于 2000 年 3 月 12 日正式开业，迄今为止已经成立21周年了，是泉州市颇具影响力的一家以经营电脑及现代办公设备的大型电脑专业市场。多年来，益华电脑城一直以保证电脑品质为根本，以快捷有效地售后维修为保障，精心打造一个低价、时尚、高性价比的电脑城。</p>

                    <p>立足泉州21年，我们始终坚持“诚信经营、开拓创新、团结协作、共谋发展”的经营宗旨，目前汇集了 300 余家生产厂家和经营公司，经营项目囊括电脑整机，笔记本电脑、电脑配件、DIY 、数码产品、软件、网络、外设以及办公设备耗材等，拥有国内外众多知名IT品牌产品，如联想、华硕、戴尔、惠普、爱普生、华为等。产品种类齐全繁多，直接主导着闽南地区IT市场的交易动态和消费趋势。其发展宗旨是以建立大格局、大规模、长期稳定繁荣的大型电脑专业市场，增强泉州电脑市场销售竞争能力，发挥市场集群优势，为经营者、消费者提供全方位的优质服务。</p>
                </div>
            </div>
        </section>
        <section class="section-x">
            <div class="article-title"><pre>近期项目</pre></div>
            <div class="art-items">
                <div class="art-item">
                    <div><img src="@/assets/images/yucaiwan.png" alt="御才湾" class="art-img"></div>
                    <div class="art-content">
                       <p class="art-title"><pre>益华御才湾</pre></p>
                        <div class="art-p">
                            <p>项目总用地面积43203平方米，总建筑面积126597.64平方米。本着缔造城市益生活的理念，结合了北方采光以及风向等特色，所有户型均采用纯板式南北通透设计，建筑与景观融合，打造风景中的建筑，建筑复古高贵典雅，富有归属感品质感，欧洲古典屋顶，形象高档，富有美感，立面凸凹造型设计，保证采光以及观景，各个楼体层高不同，横向视觉错落有致，多个超大观景阳台，垂直视觉丰富，楼宇排布错落有致，符合北方光照特点，立面颜色下深上浅，根基稳重形象大气。</p>
                        </div>
                    </div>
                </div>
                <div class="art-item">
                    <div><img src="@/assets/images/xingjin.png" alt="兴进豪园三期" class="art-img"></div>
                    <div class="art-content">
                       <p class="art-title"><pre>兴进豪园三期</pre></p>
                        <div class="art-p">
                            <p>项目总占地面积约10万平，建筑面积约34万平，分三期开发，总共18栋楼。项目所在的城北片区，位于石狮与晋江的交界处，并与泉州隔湾相望，是石狮的门户位置，也是石狮发展最成熟的片区，与北环路的直线距离不到800米，坐享晋江石狮同城化建设的利好。园区设计是风水学与绿色生态美学的完美结合，景观中轴如玉带环腰，南北延伸，聚财聚气，呈上吉富贵格局，中庭采用欧式园林风格设计，层次分明。</p>
                        </div>
                    </div>
                </div>
                <div class="art-item">
                    <div><img src="@/assets/images/huangfu.png" alt="皇府御园" class="art-img"></div>
                    <div class="art-content">
                       <p class="art-title"><pre>皇府御园</pre></p>
                        <div class="art-p">
                            <p>项目总占地面积为19万平米土地，一笔落成103幢独栋、90套叠加别墅，约0.53超低容积率，建筑密度18.7%，绿地率大于53%，独栋别墅占地1000平至2000平之间。坐北朝南，背山面海，俯瞰厦金海域，远观大小金门。16万平米园林风光，源自欧洲皇家风格，加拿利海枣、香樟、杜松……数十种珍稀树种，构造错落有致的立体景观。坐拥9公里世界级黄金海岸线，西为国家会计学院、海悦山庄，东为将军楼，文武拱卫，成藏风纳气的聚宝盆格局。</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'Home'
    }
</script>
